module.exports = __webpack_public_path__ + "img/pi-left.4b30e1f6.jpg";